import * as reportTypes from '../types/reportTypes'

const initialState = {
  allData: null,
  allNumbersData: null,
  startDate: '',
  endDate: '',
  startTime: '',
  endTime: '',
  category: [],
  product: [],
  shopname: [],
}

const reportReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case reportTypes.GET_DAYWISE_ANALYSIS:
      return {
        ...state,
        allData: payload,
      }
    case reportTypes.GET_DAYWISE_ANALYSIS_SEARCH:
      return {
        ...state,
        allData: payload,
        startDate: payload?.startDate,
        endDate: payload?.endDate,
        category: payload?.productCategory,
        product: payload?.product,
        shopName: payload?.location,
      }
    case reportTypes.GET_CONSOLIDATED_DAYWISE_ANALYSIS:
      return {
        ...state,
        allData: payload,
        startDate: payload?.startDate,
        endDate: payload?.endDate,
      }
    case reportTypes.GET_CONSOLIDATED_DAYWISE_ANALYSIS_SEARCH:
      return {
        ...state,
        allData: payload,
        startDate: payload?.startDate,
        endDate: payload?.endDate,
        category: payload?.productCategory,
        product: payload?.product,
        shopName: payload?.location,
      }
    case reportTypes.GET_TIMEWISE_ANALYSIS:
      return {
        ...state,
        allData: payload,
      }
    case reportTypes.GET_TIMEWISE_ANALYSIS_SEARCH:
      return {
        ...state,
        allData: payload,
        startDate: payload?.startDate,
        endDate: payload?.endDate,
        startTime: payload?.startTime,
        endTime: payload?.endTime,
        category: payload?.productCategory,
        product: payload?.product,
        shopname: payload?.location,
      }
    case reportTypes.GET_HOURLY_ANALYSIS:
      return {
        ...state,
        allData: payload,
      }
    case reportTypes.GET_SHOPWISE_ANALYSIS:
      return {
        ...state,
        allData: payload,
      }
    case reportTypes.GET_MISREPORTED_ANALYSIS:
      return {
        ...state,
        allData: payload,
      }
    case reportTypes.GET_MISREPORTED_INVOICES:
      return {
        ...state,
        allNumbersData: payload,
      }
    case reportTypes.GET_HOURLY_MOBILES:
      return {
        ...state,
        allNumbersData: payload,
      }
    case reportTypes.GET_CATEGORYWISE_ANALYSIS:
      return {
        ...state,
        allData: payload,
      }
    case reportTypes.GET_NEWRETURNING_ANALYSIS:
      return {
        ...state,
        allData: payload,
      }
    case reportTypes.GET_INCLUSION_ANALYSIS:
      return {
        ...state,
        allData: payload,
      }
    case reportTypes.GET_INCLUSION_ANALYSIS_CUS_YEAR:
      return {
        ...state,
        allData: payload,
      }
    case reportTypes.GET_INCLUSION_TABLE_DATA:
      return {
        ...state,
        allData: payload,
      }
    default:
      return state
  }
}

export default reportReducer
